const SEO = [
	{
		page: "home",
		description:
			"I am a Full Stack developer with expertise in Node.js and react js flutter . I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: [""],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: [""],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: [""],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: [""],
	},
	{
		page: "certifications",
		description:
			"Verified badges and certifications from Credly, Udemy, and HackerRank.",
		keywords: ["certifications", "credly", "udemy", "hackerrank"],
	},
];

export default SEO;
